import axios from "axios";

export default function ProductDetailPage({ item }) {
    // check if product is fetched from backend

    function handleSell(e) {
        //alert("Sell functionality not implemented yet.");
        // TODO: Implement sell functionality
        e.preventDefault();
        const qr_id = window.localStorage.getItem("qr_id");

        axios.post(`${process.env.REACT_APP_API_URL}/item/${qr_id}/sell`, {
            itemId: item.id,
            // other necessary data
        },
            {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem("token")}`
                }
            }
        )
            .then(response => {
                alert("Sell Successful")
                console.log('Sell successful:', response.data);
                window.location.reload();
                // Handle successful sell (e.g., update UI, notify user)
            })
            .catch(error => {
                alert('Please try again later')
                console.error('Error selling item:', error);
                // Handle error (e.g., show error message to user)
            });

    }
    return (
        <>
            <div className="App">
                <header className="App-header">
                    <section className="top-left-corner">
                        <img src="https://pub-a3772f2b02704b91829728f4cc7bbe15.r2.dev/logo(new).svg" className="logo" alt="logo" />
                        <p>
                            Product Preview
                        </p>
                    </section>
                </header>
                <main>
                    <div id="product-detail">
                        <h2>{item.name}</h2>

                        <p>Description: {item.description}</p>
                        <p>Category: {item.category}</p>
                        <p>Brand: {item.brand}</p>
                        <p>Price: {item.price} ETB</p>
                        <hr />
                        <section class="actions">
                            {!item.sold && <button id="sellBtn" onClick={handleSell}>Sell</button>}
                            {item.sold && <p style={{ color: 'red', fontWeight: 'bold' }}>SOLD</p>}

                            <button id="backBtn" onClick={() => window.location.href = '/dashboard'}>Go To Dashboard</button>
                        </section>
                    </div>
                </main>
            </div>

        </>
    )
}